import { render, staticRenderFns } from "./AnnouncementListPage.vue?vue&type=template&id=e7491ffc"
import script from "./AnnouncementListPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports